import {createSelector} from "reselect";
import {IStore} from "modules/types";
import {getPlayers} from "modules/selectors";
import {getStatsPlayersList, IStatsTableItem} from "modules/utils";

export const getStatsState = ({statsReducer}: IStore) => statsReducer;

export const getStats = createSelector(getStatsState, ({stats}) => stats);

export const getStatsCentreTableRows = createSelector(
	getStatsState,
	({statsCentre}) => statsCentre
);

export const getPlayersWithStats = createSelector(getPlayers, (players) => {
	const list: IStatsTableItem[] = [];

	list.push(...getStatsPlayersList(players, false));

	return list;
});
